import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.articlePackSizes.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.articlePackSizes.actionsLoading;
export const getItems = (state:RootState) => state.articlePackSizes.items;
export const getItemsSelect = (state:RootState) => state.articlePackSizes.dropDownItems;
export const getItemsCount = (state:RootState) => state.articlePackSizes.itemsCount;
export const getItemForEdit = (state:RootState) => state.articlePackSizes.itemForEdit;
export const getError = (state:RootState) => state.articlePackSizes.error;
export const getErrorAction = (state:RootState) => state.articlePackSizes.errorAction;
export const validationErrors = (state: RootState) => state.articlePackSizes.validationErrors;
